import axios from 'axios'
import { getBaseUrl, USE_HEFENG,USE_CAIYUN, USE_GAODE, API_HEFENG_KEY, API_GAODE_KEY, LOCATION, CITY_CODE } from '@/utils/config'
import { Toast } from 'vant'

// create an axios instance
const service = axios.create({
  baseURL: getBaseUrl(), // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    //和风api固定参数设置
    if (config.method == 'get' && USE_HEFENG) {
      config.params = {
        key: API_HEFENG_KEY,
        location: LOCATION,
        ...config.params
      }
    }
    //高德api固定参数配置
    if (config.method == 'get' && USE_GAODE) {
      let adCode = localStorage.getItem('adCode') || '370212'
      config.params = {
        key: API_GAODE_KEY,
        city: adCode,
        extensions: 'all',
        ...config.params
      }
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    //兼容三套API
    let success = false
    if(USE_HEFENG){
      success = res.code == '200'
    }
    if(USE_CAIYUN){
      success = res.status == 'ok' 
    }
    if(USE_GAODE){
      success = res.status == '1'
    }
    // if the success value is not true, it is judged as an error.
    if (!success) {
      Toast.fail({
        message: res.message || 'Error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Toast({
      message: error.message,
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
